// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5772b50a","228":"f208bf4f","243":"57a09e4e","288":"6dfef639","497":"133ae678","655":"f5ed9745","696":"d4144469","795":"2b886e8b","958":"c3ecd924","970":"debc2e77","974":"8e85ca21","996":"933eeff7"}[chunkId] + ".chunk.js";
};